export default __webpack_public_path__ + "static/media/help-circle-svgrepo-com.b58fec84.svg";